import React, { useState } from 'react';
import ContactForm from '../components/ContactForm';
import ContactList from '../components/ContactList';

const Contacts = ({ user, setView }) => {
  const [selectedContact, setSelectedContact] = useState(null);
  const [formKey, setFormKey] = useState(Date.now());

  const handleFinishEditing = () => {
    setSelectedContact(null);
    setFormKey(Date.now()); 
  };

  const handleSelectContactToEdit = (contact) => {
    setSelectedContact(contact);
    window.scrollTo(0, 0); 
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>Manage Contacts</h2>
        {/* CORRECTED to point to companyDashboard */}
        <button type="button" className="cancel-button" style={{padding: '0.5rem 1rem'}} onClick={() => setView('companyDashboard')}>
            Back to Dashboard
        </button>
      </div>

      <div className="contacts-container">
        <div className="contact-form-section">
          <ContactForm 
            key={formKey}
            user={user} 
            contactToEdit={selectedContact}
            onActionComplete={handleFinishEditing}
            onCancel={() => setView('companyDashboard')} // Also corrected the onCancel prop
          />
        </div>
        <div className="contact-list-section">
          <h3>Contact List</h3>
          <ContactList user={user} onEditContact={handleSelectContactToEdit} />
        </div>
      </div>
    </div>
  );
};

export default Contacts;